import React, { useCallback, useMemo, useRef, useState, useEffect } from "react";
import excelIcon from '../../../assets/images/excel.png';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import LoaderComponent from "../../../libraries/loader/loader";
import { getvendorcode, getBalanceFromServer,updatedonutvalue,updateclosurestatusvalue,Fetcherpdata_1,Fetchexecutequery,Fetchbankdata_1,Fetchbankinvoicedetails1,Fetchbankdata,Fetchexternaldetails, getProcessingLayerDataFromServer, getProcessingLayerDataWithStatusFromServer, getUpdateMatchRecordsFromServer, getUpdateUnMatchRecordsFromServer, getUpdateDuplicateRecordsFromServer, getUpdateContraRecordsFromServer, getProcessingLayerDataReturnFromServer, getUpdateGlBalFromServer, getUpdateBankBalFromServer, Fetchbankinvoicedetails,Fetcherpdata, Fetchmatchedutrdata, Fetchmatchedutrdata1, updatestatusvalue, allocateupdatestatusvalue, fetchmonthwisedata1, getdonutseriesdata, getkpidatarecon, getpaymenthistory, getstatustypeslist, getremarksdata, fetchmonthwisedatanew, getpaymenthistorynew, getdataforcardsrecon } from '../../../services/process/BRS1/brsService7';
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
// import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileLines, faStreetView } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import Modal from 'react-bootstrap/Modal';
import { Icon, Input, Button, Dropdown, Grid, Card, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import RenderGrid from './grid';
import "./reconSummary.css";
// import DynamicDonutChart from './donutchart';


function ReconSummary() {
  const [loaderOpen, setLoaderOpen] = useState(false);
  
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [link, setLink] = useState();
  const [options, setOptions] = useState([]);
  const [clientids, setclientids] = useState([]);
  const [clientids1, setclientids1] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedOption1, setSelectedOption1] = useState('');
  const [layerId, setLayerId] = useState('');
  const [erpBalance, setErpBalance] = useState(0.00);
  const [bankBalance, setBankBalance] = useState(0.00);
  const [chartHidden, setChartHidden] = useState(true);
  const [doughnutLabel, setDoughnutLabel] = useState([]);
  const [doughnutdata, setDoughnutData] = useState([]);
  const [label, setLabel] = useState('');
  const [unMatchedHidden, setUnMatchedHidden] = useState(false);
  const [searchHidden, setSearchHidden] = useState(true);
  const [intGridData, setIntGridData] = useState([]);
  const [extGridData, setExtGridData] = useState([]);
  const [intDebit, setIntDebit] = useState(0.00);
  const [intCredit, setIntCredit] = useState(0.00);
  const [extDebit, setExtDebit] = useState(0.00);
  const [extCredit, setExtCredit] = useState(0.00);
  const [intDate, setIntDate] = useState(undefined);
  const [extDate, setExtDate] = useState(undefined);
  const [amountTolerance, setAmountTolerance] = useState(0.00);
  const [openGridHidden, setOpenGridHidden] = useState(true);
  const [openIntGridData, setOpenIntGridData] = useState([]);
  const [openExtGridData, setOpenExtGridData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const agIntGridRef = useRef(null);
  const agExtGridRef = useRef(null);
  const intMatchingRows = [];
  const extMatchingRows = [];
  const [internalAmount, setInternalAmount] = useState(0.00);
  const [externalAmount, setExternalAmount] = useState(0.00);
  const [matchHidden, setMatchHidden] = useState(true);
  const [contraHidden, setContraHidden] = useState(true);
  const [duplicateHidden, setDuplicateHidden] = useState(true);
  const [unMatchHidden, setUnMatchHidden] = useState(false);
  const [intId, setIntId] = useState('');
  const [bankclosure, setBankclosure] = useState('');
  const [erpclosure, setErpclosure] = useState('');
  const [monthclosure, setMonthclosure] = useState('');

  const [intName, setIntName] = useState("");
  const [extName, setExtName] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [unMatchStyles, setUnMatchStyles] = useState(undefined);
  const [selectCheckBox, setSelectCheckBox] = useState(undefined);
  const [searchText, setSearchText] = useState('');
  const [hideLabels, setHideLabels] = useState(false);
  const chartRef = useRef(null);

  const [arcolumnnames, setarcolumnnames] = useState([]);
  const [bankcolumnnames, setbankcolumnnames] = useState([]);

  const [modelcolumnnames, setmodelcolumnnames] = useState([]);
  const [modelcolumnnames1, setmodelcolumnnames1] = useState([]);

  const [show3, setShow3] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show5, setShow5] = useState(false);
  const [show6, setShow6] = useState(false);

  const [matchedData, setMatchedData] = useState({});
  const [unmatcheddata, setunmatcheddata] = useState({});
  const [alldata, setalldata] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = date => {
    setSelectedDate(date);
    // You can perform any additional logic here when the date is selected
  };


  const [selectedLabel, setSelectedLabel] = useState('');

  const [finalinternaldata, setfinalinternaldata] = useState([]);
  const [finalexternaldata, setfinalexternaldata] = useState([]);
  const [ismatched, setismatched] = useState({});


  const [customer_advice_location, setcustomer_advice_location] = useState('');

  const [erpbalance, seterpbalance] = useState('');
  const [bankbalance, setbankbalance] = useState('');
  const [difference, setdifference] = useState('');

  const [optionslist, setOptionslist] = useState([]);

  const [matchidslist, setmatchidslist] = useState([]);


  const [remarkscol, setremarkscol] = useState([]);
  const [remarksdata, setremarksdata] = useState([]);

  const [remarkscol1, setremarkscol1] = useState([]);
  const [remarksdata1, setremarksdata1] = useState([]);
  const [selectedOption99, setSelectedOption99] = useState('');


  const [dropdown1, setdropdown1] = useState({ value: "Day", label: "Day" });
  const [dropdown2, setdropdown2] = useState({});

  const [userid, setuserid] = useState(userCredentials["user_id"]);


  const [barwidth, setbarwidth] = useState('40%');
  const [barwidth1, setbarwidth1] = useState('40%');

  const payment_history_dropdowns = [
    { value: "Day", label: "Day" },
    { value: "Week", label: "Week" },
    { value: "Month", label: "Month" },
    { value: "Year", label: "Year" },
  ];

  const payment_history_dropdowns1 = [
    { value: "This week", label: "This week" },
    { value: "This month", label: "This month" },
    { value: "Last week", label: "Last week" },
    { value: "Last month", label: "Last month" },
    { value: "Last 2 month", label: "Last 2 month" },
    { value: "Last 6 month", label: "Last 6 month" },
  ];

  const handleDropdownChange = (event) => {
    setSelectedOption99(event.target.value);
  };


  const changedropdown2 = (event) => {
    setdropdown2(event)
  }

  const chartData1 = {
    labels: doughnutLabel,
    series: doughnutdata,
  };



  const internaltotal1 = React.useMemo(() => {
    if (openIntGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      let total = 0.0;
      openIntGridData.forEach((row) => {
        // const Amount = row['Amount'];

        // Perform the arithmetic operation
        // total = total - (withdrawalAmt - depositAmt);
        // console.log('row', row);
        // total = total + Amount
        const Amount = parseFloat(row['Credit']); // Convert the amount to a number
	const Amount2 = parseFloat(row['Debit']);
        total += Amount-Amount2 ;
        console.log('intColumnDefs',total,Amount,Amount2);


      })

      const usFormatter = new Intl.NumberFormat("en-IN");
      const formattedTotal = usFormatter.format(total);
      setInternalAmount(formattedTotal);
      return [];
    }

    return [];
  }, [openIntGridData]);

const externaltotal1 = React.useMemo(() => {
    if (openExtGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      let total = 0.0;
      const cr = 'cr';
      const dr = 'dr';
      let withdrawalAmtStr, depositAmtStr; // Declare the variables outside of the if blocks
      
      openExtGridData.forEach((row) => {
        if (row[cr/dr] === "cr") {
            withdrawalAmtStr = row['Transaction_Amount(INR)'];
            depositAmtStr = null; // or any other value you prefer
        } else if (row[cr/dr] === 'dr') {
            withdrawalAmtStr = null; // or any other value you prefer
            depositAmtStr = row['Transaction_Amount(INR)'];
        } else {
            // Handle the case when row[cr/dr] is neither 'cr' nor 'dr'
            // For example, you can set withdrawalAmtStr and depositAmtStr to null or some default values
            withdrawalAmtStr = null;
            depositAmtStr = null;
        }

        //console.log('Withdrawal_Amt (raw):', withdrawalAmtStr);
        //console.log('Deposit_Amt (raw):', depositAmtStr);

        // Parse known numeric values
        const withdrawalAmt = parseFloat(withdrawalAmtStr);
        const depositAmt = parseFloat(depositAmtStr);

        console.log('Withdrawal_Amt (parsed):', withdrawalAmt);
        console.log('Deposit_Amt (parsed):', depositAmt);
        total += depositAmt - withdrawalAmt;
        console.log('1234', total);
      });
      
      const usFormatter = new Intl.NumberFormat("en-IN");
      const formattedTotal = usFormatter.format(total);
      setExternalAmount(formattedTotal);
      console.log('extColumnDefs', total);
      
      return [];
    }

    return [];
}, [openExtGridData]);


  const DynamicDonutChart = ({ options, series, onClick }) => {


    const handleDataPointSelection = (event, chartContext, config) => {
      console.log('Data:', chartData.series, chartData.options.labels);
      console.log('Event:', event);
      if (config && config.w && config.w.config && config.w.config.labels && config.dataPointIndex !== undefined) {
        const selectedLabel = config.w.config.labels[config.dataPointIndex];
        if (selectedLabel) {
          console.log('selectedLabel', selectedLabel);
          onClick(selectedLabel);
        }
      }
    };

    const chartData = {
      series: series,
      options: {
        labels: options,
        colors: ['#264be0', '#5a63c4', '#0A2352', '#b84dff', '#ff944d', '#00cccc'],
        legend: {
          onItemClick: {
            toggleDataSeries: false,
          },

        },
        chart: {
          width: 28,
          height: 37,
          type: 'donut'
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270
          },
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          type: 'gradient',
        },
        
        title: {
          text: ''
        },

        responsive: [{
          breakpoint: 48,
          options: {
            chart: {
              width: 20,
              height: 25,
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        chart: {
          events: {
            dataPointSelection: handleDataPointSelection
          }
        }
      },
    };

    useEffect(() => {
      if (chartData.series.length > 0) {
        // Reinitialize the chart when data is available
        chartData.options.chart.events = {
          dataPointSelection: handleDataPointSelection
        };
      }
    }, [chartData.series]);  

    return (
      <div id="chart-container">
        <ReactApexChart options={chartData.options} series={chartData.series} type="donut" />
      </div>
    );
  };

  const [selectedDate99, setSelectedDate99] = useState('');

  // Function to handle the change in the date input
  const handleDateChange99 = (event) => {
    setSelectedDate(event.target.value); // Update the selected date in state
  };

  const updatestatuscolumn = (selectedLabel) => {
    const intern_id_1 = openIntGridData.map(item => item.primary_id);
    const intern_id = `(${intern_id_1.join(', ')})`;
    console.log(intern_id)

    const extern_id_1 = openExtGridData.map(item => item.primary_id);
    const extern_id = `(${extern_id_1.join(', ')})`;

    let payload = {
      // 'set_column' : 'status',
      "schema_name" : "Thermax_BRS",
      "extern_table" : selectedOption.value,
      "intern_table" : selectedOption.id,
      "set_column" : {"status" : selectedLabel.value},
      // "intern": {"primary_id": openIntGridData.map(item => item.primary_id)},

      'where': [{ 'primary_id': intern_id }],
      'where1': [{ 'primary_id': extern_id }],
      
      // "extern": openExtGridData.map(item => ({ "primary_id": item.primary_id }))
      // "extern": [{ 'primary_id': extern_id }]
    }

    console.log('payload', payload);
    var getProcessingLayerDataWithStatus = updatestatusvalue();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );

  }


  const updatestatuscolumn1 = (selectedLabel) => {
    // const intern_id_1 = openIntGridData.map(item => item.primary_id);
    // const intern_id = `(${intern_id_1.join(', ')})`;
    // console.log(intern_id)

    const extern_id_1 = openExtGridData.map(item => item.primary_id);
    const extern_id = `(${extern_id_1.join(', ')})`;

    let payload = {
      // 'set_column' : 'status',
      "schema_name" : "BRS",
      "table" : selectedOption.value,
      // "table" : "erp",
      "set_column" : {"status" : selectedLabel.value},
      // "intern": {"primary_id": openIntGridData.map(item => item.primary_id)},

      'where': [{ 'primary_id': extern_id }],
      
      // "extern": openExtGridData.map(item => ({ "primary_id": item.primary_id }))
      // "extern": [{ 'primary_id': extern_id }]
    }

    console.log('payload', payload);
    var getProcessingLayerDataWithStatus = updatestatusvalue();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );

  }

  // const checktotal = () => {


  //   return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
  //     .then(
  //       response => {
  //         console.log("Processing Layer Data With Status!!!", response)

  //       }
  //     ).catch(
  //       error => {
  //         console.log("Error in Processing Layer Data WIth Status!!!", error);
  //       }
  //     );


    
  // }

  const ClickSaveButton = () => {
    // checktotal()
    updatestatuscolumn(ismatched);
    // updatestatuscolumn1(ismatched);
    
  }

  const ClickSaveButton1 = (value) => {
    updatestatuscolumn(value);
    console.log('value', value);
  }

  const [selectedval, setselectedval] = useState('');

  
  const handleSelectionmatched = (event) => {
    setismatched(event);
    setselectedval(event.label)
  }

  const handleSelectionmatched1 = () => {

    console.log('called', selectedOption, selectedOption1, options);

  }

  const [isMultiSelect, setisMultiSelect] = useState('single');

  const handleChartClick = (label) => {    
    if(label == 'All'){
      Fetchbankinfo_(label)
      Fetchbankinfo_1(label)
    }else{
      Fetchbankinfo(label)
      Fetchbankinfo1(label)
    }
    setUnMatchedHidden(false);
  };

  const intColumnDefs3 = React.useMemo(() => {
    if (modelcolumnnames1?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(modelcolumnnames1[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [

        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 100
        })),
      ];
      setmodelcolumnnames(intColumnDefs);
      // console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [modelcolumnnames1]);

  function getgridClickedDataReturn(selectedLabel) {
    let payload = {
 	query: `select * from Thermax_BRS.${selectedOption.value} where Match_id = '${selectedLabel}';`
	
    }
    console.log('payload---', payload)

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    //let payload = {
      
      //"match_id": selectedLabel,

    //}

    //var getProcessingLayerDataWithStatus = Fetchexternaldetails();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)
          let data = response["data"];
          console.log('data', data);
          setmodelcolumnnames1((prevState) => [
            ...prevState,
            ...data]);

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );

  }

  const intColumnDefs1 = React.useMemo(() => {
    if (intGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(intGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key.replace(/_/g, ' '),
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 130
        })),
      ];
      setarcolumnnames(intColumnDefs);
      console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [intGridData]);

  const intColumnDefs10 = React.useMemo(() => {
    if (extGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(extGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 130
        })),
      ];
      setbankcolumnnames(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [extGridData]);


  const handleOpenModal = () => {
    setModalIsOpen(true);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };


  const intColumnDefs2 = React.useMemo(() => {
    if (remarksdata1?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(remarksdata1[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 100
        })),
      ];
      setremarkscol1(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [remarksdata1]);



  const fetchmonthwisedataAll = (event) => {
    if (event) {
      let payload = {
        'client_ids': event.label,
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = fetchmonthwisedatanew();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response fetch month wise data new!!!", response);
            let data = response["data"];
            let data1 = data['data'];
            setremarksdata1(data1);
            setShow6(true);
          }

        )
        .catch((error) => {

          console.error("Error in POST request:", error);
        });
    }
  }


  const fetchpaymenthistoryAll = (event) => {
    if (event) {
      let payload = {
        'client_ids': event.label,
        'key': dropdown1.value
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = getpaymenthistorynew();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response get payment history data new!!!", response);
            let data = response["data"];
            let data1 = data['data'];
            setremarksdata1(data1);
            setShow6(true);

          }

        )
        .catch((error) => {

          console.error("Error in POST request:", error);
        });
    }
  }

  const handleBarClick = () => {
    fetchmonthwisedataAll(selectedOption1)
  };

  const handleBarClick1 = () => {
    fetchpaymenthistoryAll(selectedOption1)
  };

  const labelslist = [];
  const seriesdata = [];

  const [barlabellist, setbarlabellist] = useState([]);
  const [barserieslist, setbarserieslist] = useState([]);

  const chartData5 = {
    series: [
      {
        name: 'Series 1',
        data: barserieslist,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 200,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: barwidth1
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: barlabellist,
      },
      fill: {
        colors: ['#3B3C36'],
      },
    },
  };

  const BarChart = () => {
    const options = {
      chart: {
        type: 'bar',
      },
      xaxis: {
        categories: barlabellist,
        fill: {
          colors: ['#0a2352'],
        },
      },
    };

    const series = [
      {
        name: 'Month wise data',
        data: barserieslist,

      }

    ];

    return (
      <div>

        <ReactApexChart options={chartData5.options} series={chartData5.series} type="bar" height={255} onClick={handleBarClick} />
      </div>
    );
  };


  const [barlabellist1, setbarlabellist1] = useState([]);
  const [barserieslist1, setbarserieslist1] = useState([]);


  const chartData2 = {
    series: [
      {
        name: 'Series 1',
        data: barserieslist1,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 300,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: barwidth
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: barlabellist1,
      },
      fill: {
        colors: ['#0a2352'],
      },
    },
  };

  const BarChart1 = () => {
    const options = {
      chart: {
        type: 'bar',
      },
      xaxis: {
        categories: barlabellist1,
        fill: {
          colors: ['#0a2352'],
        },
      },
    };

    const series = [
      {
        name: 'Month wise data',
        data: barserieslist1,
      }

    ];

    return (
      <div>

        <ReactApexChart options={chartData2.options} series={chartData2.series} type="bar" height={200} onClick={handleBarClick1} />
      </div>
    );
  };

  const fetchmonthwisedata = (event) => {
    if (event) {
      let payload = {
        'client_ids': event.label,
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = fetchmonthwisedata1();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response fetch month wise data!!!", response);
            let data = response["data"];
            let data1 = data['data']

            const ageBuckets = data1.map(item => item.AgeBucket);
            const totalInvoiceAmounts = data1.map(item => item.TotalInvoiceAmount);
            // setDoughnutData([60, 30, 150])
            setChartHidden(false);
            setbarlabellist(ageBuckets);
            setbarserieslist(totalInvoiceAmounts);

            let arrayLength = [];
            let datesArray = ageBuckets;
            arrayLength = datesArray.length;

            if (arrayLength == 3) {
              setbarwidth1('40%')
            } else if (arrayLength == 2) {
              setbarwidth1('30%')
            } else if (arrayLength == 4) {
              setbarwidth1('45%')
            } else if (arrayLength == 5) {
              setbarwidth1('50%')
            } else {
              setbarwidth1('10%')
            }

          }

        )
        .catch((error) => {
          // setDoughnutData([60, 30, 150])
          setChartHidden(false);
          console.error("Error in POST request:", error);
        });
    }
  }


  const fetchpaymenthistory = (event, param) => {
    if (event) {
      let payload = {
        'client_ids': event,
        'key': param
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = getpaymenthistory();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response get payment history data!!!", response);
            let data = response["data"];

            // setDoughnutData([60,30,150])
            setChartHidden(false);
            setbarlabellist1(data['labels']);
            setbarserieslist1(data['values']);
            let arrayLength = [];
            let datesArray = data['labels'];
            arrayLength = datesArray?.length;

            if (arrayLength == 3) {
              setbarwidth('40%')
            } else if (arrayLength == 2) {
              setbarwidth('30%')
            }  else if (arrayLength == 1) {
              setbarwidth('20%')
            } else {
              setbarwidth('30%')
            }

            // const formatAmount = (amount) => {
            //   return amount.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ",");
            // };

            // let datta = data['values'];
            // datta.forEach((data) =>{
            //   const formattedAmount = formatAmount(data);
            //   console.log('formattedAmount', formattedAmount);
            // })


          }

        )
        .catch((error) => {
          // setDoughnutData([60,30,150])
          setChartHidden(false);
          console.error("Error in POST request:", error);
        });
    }
  }

  const Fetchbankinfo1 = (label) => {
    let payload = {
 	query: `select * from Thermax_BRS.${selectedOption.value} where status = '${label}';`
	
    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          let data = response["data"];
          setExtGridData(data)
        }
      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }

  const Fetchbankinfo = (label) => {

    let payload = {
 	query: `select * from Thermax_BRS.${selectedOption.id} where status = '${label}';`
	
    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();



    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          let data = response["data"];

          setIntGridData(data);

        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }


  const Fetchbankinfo_1 = (label) => {

    let payload = {
 	query: `select * from Thermax_BRS.${selectedOption.value};`
	
    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
	
    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          let data = response["data"];
          setExtGridData(data);
        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }

  const Fetchbankinfo_ = (label) => {

    let payload = {
 	query: `select * from Thermax_BRS.${selectedOption.id};`
	
    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();


    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          let data = response["data"];
          setIntGridData(data);

        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }

  const clickedmatchbtn = (internaldata, externaldata) => {
    const filterKey = "Closed";
    const filteredData = internaldata.filter(item => item.status === filterKey);
    const filteredData1 = externaldata.filter(item => item.status === filterKey);
    let length = filteredData.length + filteredData1.length;
    doughnutdata.push(length);

    setDoughnutData(doughnutdata);
    // let matcheddata1 = {
    //   'internal_data': filteredData,
    //   'external_data': filteredData1
    // };
    // setMatchedData(matcheddata1);
    // console.log('filteredData', matcheddata1 );
  }

  const clickedunmatchbtn = (internaldata, externaldata) => {
    const filterKey = "Open";
    const filteredData2 = internaldata.filter(item => item.status === filterKey);
    const filteredData3 = externaldata.filter(item => item.status === filterKey);
    let length = filteredData2.length + filteredData3.length;
    doughnutdata.push(length);
    setDoughnutData(doughnutdata);
    // setunmatcheddata(
    //   {
    //   'internal_data': filteredData2,
    //   'external_data': filteredData3
    //   }
    // )
    // console.log('filteredData1', filteredData2, filteredData3,length);
  }

  const clickedallbtn = (internaldata, externaldata) => {
    let length = internaldata.length + externaldata.length;
    doughnutdata.push(length);
    setDoughnutData(doughnutdata);
    // setalldata(
    //   {
    //   'internal_data': internaldata,
    //   'external_data': externaldata
    //   }
    // )
    // console.log('finalinternaldata', internaldata, externaldata, length);
  }

  useEffect(() => {
    BrsTypeList();
    fetchstatuscolumntypeslist();
  }, []);


  const fetchstatuscolumntypeslist = (event) => {

    let payload = {
      'client_ids': '',
    }

    var FileUploadCredentials = getstatustypeslist();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response fetch status types list data!!!", response);
          let data = response["data"];
          let data1 = data['labels'];
          const dropdownOptions = data1.map((item) => ({ value: item.name, label: item.name }));
          setOptionslist(dropdownOptions);
        }
      )
      .catch((error) => {

        console.error("Error in POST request:", error);
      });

  }

  const fetchdonutchartdata = (event) => {
    if (event) {
      let payload = {
        // 'client_ids': event.label,
        'schema_name': 'Thermax_BRS',
        'table1' : event.id,
        'table2' : event.value,
        //'ACCTID_1': event.id,
        // 'erp_name_2': 'hdfc',
        // 'DIVISION_NAME_1': selectedOption1.label,
        // 'division_2': selectedOption1.label,
        // 'user_id': userCredentials["user_id"],
      }

      console.log('payload123', payload)

      var FileUploadCredentials = updatedonutvalue();


      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
  	.then(response => {
      console.log("Response:", response);
      
      let countData = response.data; // Assuming the count data is directly in the response
      // Process the count data as needed
      // console.log("Count data:", countData);
      // console.log("Groupmatch count:", countData.Groupmatch);
      // console.log("Unmatched count:", countData.Unmatched);
      // console.log("Contra count:", countData.Contra);
      // console.log("Match count:", countData.Match);
      // console.log("All count:", countData.All);

      const labels1 = Object.keys(countData);
      console.log("Labels:", labels1);

      // Get values corresponding to the labels
      const values1 = labels1.map(label => countData[label]);
      console.log("Values:", values1);

      console.log("Validate Credentials Response fetch labels data!!!", countData.keys);
      let label1 = labels1;
      let series1 = values1;
      setDoughnutLabel(label1);
      setDoughnutData(series1);
  })
  .catch(error => {
    console.error("Error in POST request:", error);
  });
    }};


  const [showDialog, setShowDialog] = useState(false);

  const handleClick = () => {
    setShowDialog(true);
    monthendbalance();
  };

  const handleClose1 = () => {
    setShowDialog(false);
  };

  

  function getKpiinfo(event) {

    let payload = {
 	query: `select bank_closing_balance,erp_closing_balance,month,id from BRS.month_end_closing_balance where accpac_id= '${event.id}' ORDER BY id DESC LIMIT 1;`
	
    }
    console.log('payload---', event)

    var getProcessingLayerData = Fetchexecutequery();

    return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status with chart data----!!!", response)
          let data = response["data"];
          let arrays = data[0]["bank_closing_balance"];
          let arrays1 = data[0]["erp_closing_balance"];

          //let arrays2 = data["total"];
          console.log('data123445',data,arrays,arrays1)

          let bank_closing_balance = parseFloat(arrays);
          let erp_closing_balance = parseFloat(arrays1);
          const bank_closing_balance_1 = parseFloat(bank_closing_balance).toLocaleString('en-IN', { style: 'currency', currency: 'INR'});
	  const erp_closing_balance_1 = parseFloat(erp_closing_balance).toLocaleString('en-IN', { style: 'currency', currency: 'INR'});          
	  const variance  = parseFloat(bank_closing_balance) - parseFloat(erp_closing_balance);
          const variance_1 = (variance).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
          seterpbalance(erp_closing_balance_1);
          setbankbalance(bank_closing_balance_1);
          setdifference(variance_1);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const changedropdown1 = (event) => {
    setdropdown1(event)
    fetchpaymenthistory(selectedOption1.value, event.value)
  }


  function handleSelection(event) {
    console.log('event', event);
    const selectedValue = event;

    setSelectedOption(selectedValue);
    getKpiinfo(event)
    fetchmonthwisedata(event);
    fetchdonutchartdata(event);

    fetchpaymenthistory(event.label, 'Day');
    const filterKey = selectedValue.label;

    // Filter the data based on the specified key
    const filteredData = clientids.filter(item => item.key === filterKey);
    // Create a Set to track unique values
    const uniqueSet = new Set();

    // Filter the data to remove duplicates
    const filteredData1 = filteredData.filter(item => {
      const value = item.value;

      // If the value is not in the Set, add it to the Set and keep the item
      if (!uniqueSet.has(value)) {
        uniqueSet.add(value);
        return true;
      }

      return false; // Skip duplicates
    });

    console.log(filteredData1);

    console.log('filteredData', filteredData);
    setclientids1(filteredData1);
    //setUnMatchedHidden(true);
    setOpenGridHidden(true);
    setChartHidden(true);
    setExternalAmount(0.00);
    setInternalAmount(0.00);
    //setMatchHidden(true);
    setDuplicateHidden(true);
    setUnMatchHidden(true);
    setSearchHidden(true);
    setContraHidden(true);
    setLabel('');

  }

  function BrsTypeList() {
    setLoaderOpen(true);
    let payload = {
      'user_id': userCredentials['user_id']
    }
    console.log('userCredentials["groups_id"],', userCredentials);
    var getProcessingLayerList = getvendorcode();
    console.log("brs", getProcessingLayerList)

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(
        response => {
          console.log("Processing customer List vendor code!!!", response)
          
          let data = response["data"];
          console.log('data', data);
          if (data) {
            // let options = data.map({label:'HDFC', value:'HDFC'});
            let options = [{ label: 'Citi bank', value: 'citibank',id: 'citierp' },{ label: 'icici bank', value: 'icici_bank',id:'icici_erp' }];
            let client_ids = data.map((row) => ({label:row.division, value:row.division}));
            // let options = ({label:'HDFC', value:'HDFC'})
            // console.log('options', options);
            setOptions(options);
            // setclientids(client_ids);
            
          }
          setLoaderOpen(false);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer List!!!", error);
          setLoaderOpen(false);
        }
      );

  }

  function processingLayerData(selectedValue, layerId) {
    setIntDebit('');
    setIntCredit('');
    setExtDebit('');
    setExtCredit('');
    setAmountTolerance('');
    setIntName('');
    setExtName('');
    setIntDate('');
    setExtDate('');
    setLoaderOpen(true);
    let payload = {
      "processing_layer": selectedValue,
      "tenants_id": 1,
      "groups_id": 1,
      "entities_id": 1,
      "processing_layer_id": layerId
    }

    var getProcessingLayerData = getProcessingLayerDataFromServer();
    console.log("url", getProcessingLayerData[0])

    return axios.post(getProcessingLayerData[1], { params: payload }, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data!!!", response)
          let data = response["data"];
          if (data["Status"] === "Success") {
            console.log("data", data);
            setDoughnutLabel(data["Label"]);
            setDoughnutData(data["Values"]);
            setIntDebit(data["int_dr"]);
            setIntCredit(data["int_cr"]);
            setExtDebit(data["ext_dr"]);
            setExtCredit(data["ext_cr"]);
            setAmountTolerance(data["amount_tolerance"]);
            setIntName(data["m_source_name_int"]);
            setExtName(data["m_source_name_ext"]);
            setChartHidden(false);
            setUnMatchHidden(true);
            setContraHidden(true);
            setIntDate(data["int_date"]);
            setExtDate(data["ext_date"]);
          }
          setLoaderOpen(false);
          return response;
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
          setLoaderOpen(false);
        }
      );

  }

  function getBalances(layerId) {
    setLoaderOpen(true);
    let payload = {
      "tenantsId": userCredentials["tenants_id"],
      "groupsId": userCredentials["groups_id"],
      "entityId": userCredentials["entities_id"],
      "mProcessingLayerId": userCredentials["m_processing_layer_id"],
      "mProcessingSubLayerId": userCredentials["m_processing_sub_layer_id"],
      "processingLayerId": layerId
    }

    var getBalance = getBalanceFromServer();

    axios.post(getBalance[1], { params: payload }, getBalance[0])
      .then(
        response => {
          console.log("Get Balance Response!!!", response)
          let data = response["data"];
          if (data["Status"] === "Success") {
            console.log("bal", data["data"]["bank_balance"])
            setBankBalance(data["data"]["bank_balance"]);
            setErpBalance(data["data"]["gl_balance"]);
            // setLoaderOpen(false);
          }
        }
      ).catch(
        error => {
          console.log("Error in Get Balance!!!", error);
          // setLoaderOpen(false);
        }
      );

  }

  function processingLayerDataReturn() {
    let payload = {
      "int_name": intName,
      "ext_name": extName,
    }

    var getProcessingLayerData = getProcessingLayerDataReturnFromServer();
    console.log("url", getProcessingLayerData[0])

    return axios.post(getProcessingLayerData[1], { params: payload }, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data!!!", response)
          let data = response["data"];
          if (data["Status"] === "Success") {
            console.log("data", data);
            setDoughnutLabel(data["Label"]);
            setDoughnutData(data["Values"]);
            setChartHidden(false);
            setUnMatchHidden(true);
            setContraHidden(true);
          }
          return response;
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );

  }

  const handleDataPointSelection1 = (event, chartContext, config) => {
    
    const selectedLabel = config.w.config.labels[config.dataPointIndex];
    console.log("selectedLabel", selectedLabel);
    console.log("intNameClicked", intName);
    setLabel(selectedLabel);
    // getChartClickedData(selectedLabel);
    setOpenIntGridData([]);
    setOpenExtGridData([]);
    setExternalAmount(0.00);
    setInternalAmount(0.00);
    setMatchHidden(true);
    setDuplicateHidden(true);
    setUnMatchHidden(true);
    setContraHidden(true);
  };

  // const handleLegendClick = () => {
  //   setChartData((prevChartData) => ({
  //     ...prevChartData,
  //     options: {
  //       ...prevChartData.options,
  //       dataLabels: {
  //         enabled: !prevChartData.options.dataLabels.enabled,
  //       },
  //     },
  //   }));
  // };

  // const [chartData, setChartData] = useState({
  //   series: doughnutdata,
  //   options: {
  //     labels: doughnutLabel,
  //     colors: ["#66cc66", "#ff4d4d", "#1a75ff", "#b84dff", "#ff944d", "#00cccc"],
  //     legend: {
  //       onItemClick: {
  //         toggleDataSeries: false,
  //         onClick: handleLegendClick,
  //       },
  //     },
  //     chart: {
  //       width: 380,
  //       type: "donut",
  //     },
  //     plotOptions: {
  //       pie: {
  //         startAngle: -90,
  //         endAngle: 270,
  //       },
  //     },
  //     dataLabels: {
  //       enabled: true, // Show labels by default
  //     },
  //     fill: {
  //       type: "gradient",
  //     },
  //     title: {
  //       text: "",
  //     },
  //     responsive: [
  //       {
  //         breakpoint: 480,
  //         options: {
  //           chart: {
  //             width: 200,
  //           },
  //           legend: {
  //             position: "bottom",
  //           },
  //         },
  //       },
  //     ],
  //   },
  // });


  useEffect(() => {

    setSearchHidden(true);

    if (label) {
      setLoaderOpen(true); // Show loader while the API call is in progress
      getChartClickedData(label);
    }
  }, [intName, extName, label]);


  const getChartClickedData = async (selectedLabel) => {
    try {
      console.log("intNameinside", intName);
      setLoaderOpen(true); // Use the passed setLoaderOpen function
      let payload = {
        "status": selectedLabel,
        "int_name": intName,
        "ext_name": extName,
      }

      var getProcessingLayerDataWithStatus = getProcessingLayerDataWithStatusFromServer();

      const response = await axios.post(getProcessingLayerDataWithStatus[1], { params: payload }, getProcessingLayerDataWithStatus[0]);
      console.log("Processing Layer Data With Status!!!", response);
      let data = response["data"];
      if (data["Status"] === "Success") {
        console.log("data", data);
        setIntGridData(data["internal_data"]);
        setExtGridData(data["external_data"]);
        setUnMatchedHidden(false);
        setSearchHidden(false);
        setOpenGridHidden(true);
        setMatchHidden(true);
        setDuplicateHidden(true);
        setUnMatchHidden(true);
        setSelectedId(null);
        setContraHidden(true);
      }
      setLoaderOpen(false); // Use the passed setLoaderOpen function to update the state

      return response;
    } catch (error) {
      console.log("Error in Processing Layer Data With Status!!!", error);
      setLoaderOpen(false); // Use the passed setLoaderOpen function to update the state
    }
  };


  // const getChartClickedData = async (selectedLabel) => {
  //   try {
  //     console.log("intNameinside", intName);
  //     setLoaderOpen(true); // Use the passed setLoaderOpen function
  //     let payload = {
  //       "status": selectedLabel,
  //       "int_name": intName,
  //       "ext_name": extName,
  //     }

  //     var getProcessingLayerDataWithStatus = getProcessingLayerDataWithStatusFromServer();

  //     const response = await axios.post(getProcessingLayerDataWithStatus[1], { params: payload }, getProcessingLayerDataWithStatus[0]);
  //     console.log("Processing Layer Data With Status!!!", response);
  //     let data = response["data"];
  //     if (data["Status"] === "Success") {
  //       console.log("data", data);
  //       setIntGridData(data["internal_data"]);
  //       setExtGridData(data["external_data"]);
  //       setUnMatchedHidden(false);
  //       setOpenGridHidden(true);
  //       setMatchHidden(true);
  //       setDuplicateHidden(true);
  //       setUnMatchHidden(true);
  //       setSelectedId(null);
  //       setContraHidden(true);
  //     }
  //     setLoaderOpen(false); // Use the passed setLoaderOpen function to update the state

  //     return response;
  //   } catch (error) {
  //     console.log("Error in Processing Layer Data With Status!!!", error);
  //     setLoaderOpen(false); // Use the passed setLoaderOpen function to update the state
  //   }
  // };


  // function getChartClickedData(selectedLabel)
  // {
  //     console.log("intNameChart", intName);
  //     setLoaderOpen(true);
  //     let payload = {
  //       "status": selectedLabel,
  //       "int_name" : intName,
  //       "ext_name" : extName,
  //     }

  //     var getProcessingLayerDataWithStatus = getProcessingLayerDataWithStatusFromServer();

  //     return axios.post(getProcessingLayerDataWithStatus[1], {params : payload}, getProcessingLayerDataWithStatus[0])
  //     .then(
  //         response => {
  //             console.log("Processing Layer Data With Status!!!", response)
  //             let data = response["data"];
  //             if (data["Status"] === "Success") {
  //               console.log("data", data);
  //               setIntGridData(data["internal_data"]);
  //               setExtGridData(data["external_data"]);
  //               setUnMatchedHidden(false);
  //               setOpenGridHidden(true);
  //               setMatchHidden(true);
  //               setDuplicateHidden(true);
  //               setUnMatchHidden(true);
  //               setSelectedId(null);
  //               setContraHidden(true);
  //             }
  //             setLoaderOpen(false);
  //             return response;
  //         }
  //     ).catch(
  //         error => {
  //             console.log("Error in Processing Layer Data WIth Status!!!", error);
  //             setLoaderOpen(false);
  //         }
  //     );

  // }

  function getChartClickedDataReturn(selectedLabel) {
    let payload = {
      "status": selectedLabel,
      "int_name": intName,
      "ext_name": extName,
    }

    var getProcessingLayerDataWithStatus = getProcessingLayerDataWithStatusFromServer();

    return axios.post(getProcessingLayerDataWithStatus[1], { params: payload }, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)
          let data = response["data"];
          if (data["Status"] === "Success") {
            console.log("data", data);
            setIntGridData(data["internal_data"]);
            setExtGridData(data["external_data"]);
            setUnMatchedHidden(false);
            setSearchHidden(false);
            setOpenGridHidden(true);
            setMatchHidden(true);
            setDuplicateHidden(true);
            setUnMatchHidden(true);
            setSelectedId(null);
            setContraHidden(true);
          }
          return response;
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );

  }

  // const intColumnDefs = React.useMemo(() => {
  //   if (intGridData.length > 0) {
  //     // Get the column names from the first row of the JSON data
  //     const keys = Object.keys(intGridData[0]);

  //     // Create column definitions with the checkbox as the first column
  //     const intColumnDefs = [
  //       {
  //         headerName: '',
  //         checkboxSelection: true,
  //         width: 50,
  //       },
  //       ...keys
  //       .filter((key) => key !== 'id') // Filter out the "id" column
  //       .map((key) => {
  //         // Calculate the maximum content width for the current column
  //         const maxWidth = intGridData.reduce(
  //           (max, data) => {
  //             const cellContent = data[key] ? data[key].toString() : '';
  //             return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
  //           },
  //           100 // Set a minimum width of 100 to avoid very narrow columns
  //         );

  //         return {
  //           headerName: key,
  //           field: key.replace(/\./g, '[""]'),
  //           sortable: true, 
  //           filter: true, 
  //           resizable: true,
  //           width: maxWidth,
  //         };
  //       }),
  //   ];

  //     return intColumnDefs;
  //   }
  //   return [];
  // }, [intGridData]);

  const intColumnDefs = React.useMemo(() => {
    if (intGridData && intGridData.length > 0) {
      const keys = Object.keys(intGridData[0]);

      const dynamicColumnDefs = [
        {
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 50,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelectionMultiple: false,
        },
        ...keys
          .filter((key) => key !== 'id')
          .map((key) => {
            // Column definition setup
            const maxWidth = intGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );
            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
              editable: true,
              cellEditor: 'agTextCellEditor',
            };
          }),
      ];

      return dynamicColumnDefs;
    }
    return [];
  }, [intGridData]);

  let gridApi;
  let gridApiInt;

  const extColumnDefs = React.useMemo(() => {
    if (extGridData && extGridData.length > 0) {
      const keys = Object.keys(extGridData[0]);

      const dynamicColumnDefs = [
        {
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 50,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelectionMultiple: false,
        },
        ...keys
          .filter((key) => key !== 'id')
          .map((key) => {
            // Column definition setup
            const maxWidth = extGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );
            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
              editable: true,
              cellEditor: 'agTextCellEditor',
            };
          }),
      ];

      return dynamicColumnDefs;
    }
    return [];
  }, [extGridData]);

  const onGridReady = (params) => {
    const { api } = params;
    gridApi = api;
  };


  // const extColumnDefs = React.useMemo(() => {
  //   if (extGridData.length > 0) {
  //     // Get the column names from the first row of the JSON data
  //     const keys = Object.keys(extGridData[0]);

  //     // Create column definitions with the checkbox as the first column
  //     const extColumnDefs = [ 
  //       {
  //         headerName: '',
  //         checkboxSelection: true,
  //         width: 50,
  //       },
  //       ...keys
  //       .filter((key) => key !== 'id') // Filter out the "id" column
  //       .map((key) => {
  //         // Calculate the maximum content width for the current column
  //         const maxWidth = extGridData.reduce(
  //           (max, data) => {
  //             const cellContent = data[key] ? data[key].toString() : '';
  //             return Math.max(max, cellContent.length * 10); // Adjust the constant factor (10) as needed
  //           },
  //           100 // Set a minimum width of 100 to avoid very narrow columns
  //         );

  //         return {
  //           headerName: key,
  //           field: key.replace(/\./g, '[""]'),
  //           sortable: true, 
  //           filter: true, 
  //           resizable: true,
  //           width: maxWidth,
  //         };
  //       }),
  //   ];

  //     return extColumnDefs;
  //   }
  //   return [];
  // }, [extGridData]);


  const OpenExtColumnDefs = React.useMemo(() => {
    if (openExtGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openExtGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 120
        })),
      ];
      // setbankcolumnnames(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [openExtGridData]);


  // const OpenIntColumnDefs = React.useMemo(() => {
  //   if (openExtGridData?.length > 0) {
  //     // Get the column names from the first row of the JSON data
  //     const keys = Object.keys(openExtGridData[0]);

  //     // Create column definitions with the checkbox as the first column
  //     const intColumnDefs1 = [
  //       {
  //         headerCheckboxSelection: true, // Add this line for the checkbox selection
  //         checkboxSelection: true, // Add this line for the checkbox selection
  //         width: 20
  //       },
  //       ...keys.map((key) => ({
  //         headerName: key,
  //         field: key,
  //         sortable: true,
  //         filter: true,
  //         resizable: true
  //       })),
  //     ];
  //     setbankcolumnnames(intColumnDefs1);
  //     console.log('intColumnDefs', intColumnDefs1);
  //     return intColumnDefs1;
  //   }
  //   return [];
  // }, [openExtGridData]);



  const OpenIntColumnDefs = React.useMemo(() => {
    if (openIntGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openIntGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 120
        })),
      ];
      // setbankcolumnnames(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [openIntGridData]);


  // const getmatchedidrecords = (matchid, isint_ext) => {
  //   console.log('123467',matchid, isint_ext)
    
  //   let payload = {
  //     "match_id": matchid,

  //   }

  //   var getProcessingLayerData = Fetchbankinvoicedetails1();
  //   console.log("url---", getProcessingLayerData[0], matchid)

  //   return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
  //     .then(
  //       response => {
  //         console.log("Processing Layer Data 123!!!", response)
  //         let data = response["data"];

  //         setOpenIntGridData(data)

  //         // setOpenExtGridData((prevData) => [
  //         //   ...prevData,
  //         //   ...data['ext_bank']]);
  //       //   setOpenIntGridData((prevData) => [
  //       //     ...prevData,
  //       //     ...data['ar_model']]);
  //       }
  //     ).catch(
  //       error => {
  //         console.log("Error in Processing Layer Data!!!", error);
  //       }
  //     );

  //     var getProcessingLayerData = Fetchexternaldetails();
  //   console.log("url---", getProcessingLayerData[0], matchid)

  //   return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
  //     .then(
  //       response => {
  //         console.log("Processing Layer Data 123!!!", response)
  //         let data = response["data"];

  //         setOpenIntGridData(data)

  //         // setOpenExtGridData((prevData) => [
  //         //   ...prevData,
  //         //   ...data['ext_bank']]);
  //       //   setOpenIntGridData((prevData) => [
  //       //     ...prevData,
  //       //     ...data['ar_model']]);
  //       }
  //     ).catch(
  //       error => {
  //         console.log("Error in Processing Layer Data!!!", error);
  //       }
  //     );

  // }

  const getmatchedidrecords = (matchid, isint_ext) => {
    console.log('123467', matchid, isint_ext)
    let payload = {
 	query: `select * from Thermax_BRS.${selectedOption.id} where match_id = '${matchid}';`
	
    }
    console.log('payload---', payload)

    var getProcessingLayerData = Fetchexecutequery();

  
    //let payload = {
      //"match_id": matchid,
    //};
  
    //var getProcessingLayerData = Fetchbankinvoicedetails1();
    //console.log("url---", getProcessingLayerData[0], matchid);
  
    axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data 123!!!", response);
          let data = response["data"];
          setOpenIntGridData(data);
        }
      )
      .catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );
  
    //var getProcessingLayerDataExternal = Fetchexternaldetails();
    //console.log("url---", getProcessingLayerDataExternal[0], matchid);
    let payload2 = {
 	query: `select * from Thermax_BRS.${selectedOption.value} where match_id = '${matchid}';`
	
    }
    console.log('payload---', payload)

    var getProcessingLayerDataExternal = Fetchexecutequery();

  
    axios.post(getProcessingLayerDataExternal[1], payload2, getProcessingLayerDataExternal[0])
      .then(
        response => {
          console.log("Processing Layer Data 123!!!", response);
          let data = response["data"];
  
          setOpenExtGridData(data);
	}
      )
      .catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );
  };
  
  const remarkscolumnnames = React.useMemo(() => {
    if (remarksdata?.length > 0) {
      // Get the column names from the first row of the JSON data
      let keys;
      if (remarksdata?.length >= 2) {
        keys = Object.keys(remarksdata[1]);
      } else {
        keys = Object.keys(remarksdata[0]);
      }

      // Create column definitions with the checkbox as the first column
      const intColumnRemarks = [

        ...keys?.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 100
        })),

      ];
      setremarkscol(intColumnRemarks);

      return intColumnRemarks;
    }
    return [];
  }, [remarksdata]);


  const fetchremarksinfo = (id) => {
    let payload = {
      "primary_id": id,
    }

    var getProcessingLayerData = getremarksdata();
    console.log('payload remarks', payload);
    return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data get remarks json data!!!", response)
          let data = response["data"];
          let data1 = data?.remarks_data;
          console.log('data1', data1);
          setremarksdata(data1);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );

  }

  const monthendbalance = () => {
    let payload = {
 	query: `select * from BRS.month_end_closing_balance where accpac_id= '${selectedOption.id}' and lock_status=0 ORDER BY id LIMIT 1;`
	
    }
    console.log('payload---', payload)

    var getProcessingLayerData = Fetchexecutequery();
    console.log('payload remarks', payload);
    return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data get remarks json data!!!", response)
          let data = response["data"];
          let data1 = data?.remarks_data;
          console.log('data1', data);
          let bankclosingbalance = data[0]["bank_closing_balance"];
          let erpclosingbalance = data[0]["erp_closing_balance"];
          let closingmonth = data[0]["month"];
          setBankclosure(bankclosingbalance );
          setErpclosure(erpclosingbalance);
          setMonthclosure(closingmonth);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );
  }

  const lockmonthendbalance = () => {
  let payload = {
    set_column: { "lock_status": 1 },
    where: [{ month: monthclosure }, { accpac_id: selectedOption.id }],
    schema_name: 'BRS',
    table: 'month_end_closing_balance'
  };
  console.log('payload---', payload);

  var getProcessingLayerData = updateclosurestatusvalue();
  console.log('payload remarks', payload);
  return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
    .then(
      response => {
        console.log("Processing Layer Data get remarks json data!!!", response);
        let data = response["data"];
  console.log('payload remarks', data);

        if (data.Status === "success") {
          // Alert for success
          alert("Success!");
        } else {
          // Alert for error
          alert("Error: " + data.message);
        }
      }
    ).catch(
      error => {
        console.log("Error in Processing Layer Data!!!", error);
      }
    );
};

  const fetchremarksinfo1 = (id) => {
    let payload = {
 	query: `select * from BRS.${selectedOption.value} where primary_id  = ${id};`
	
    }
    console.log('payload---', payload)

    var getProcessingLayerData = Fetchexecutequery();

    //let payload = {
      //"primary_id": id,
    //}

    //var getProcessingLayerData = Fetchbankinvoicedetails();
    console.log('payload remarks', payload);
    return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data get remarks json data!!!", response)
          let data = response["data"];
          let data1 = data?.remarks_data;
          console.log('data1', data1);
          setremarksdata1(data1);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );
  }


  const handleClose = () => {
    // setFormValues({ id: "", client_id: "", client_name: "", email_address: "" });
    // setShow(false);
    // setShow1(false);
    console.log('called');
    setShow2(false);
    setShow3(false);
    setOpenExtGridData([]);
    setOpenIntGridData([]);
    setcustomer_advice_location('');
    setmodelcolumnnames1([]);
    setmodelcolumnnames([]);

    setDuplicateHidden(true);
    setShow5(false);
    setShow6(false);
    setremarkscol([]);
    setremarksdata([]);
    setremarkscol1([]);
    setremarksdata1([]);
    setInternalAmount(0.00);
    setExternalAmount(0.00);

    if (agIntGridRef.current) {
      const api = agIntGridRef.current.api;
      api.deselectAll(); // This deselects all currently selected rows
    }

    if (agExtGridRef.current) {
      const api1 = agExtGridRef.current.api;
      api1.deselectAll(); // This deselects all currently selected rows
    }

    setOpenGridHidden(true);

  };

  const [intmatchid, setintmatchid] = useState([])
  const [extmatchid, setextmatchid] = useState([])

  const handleCheckboxChangeInt = (event) => {
    const selectedRow = event.api.getSelectedRows();
    console.log("internal selected checkbox row", selectedRow);

    // if (selectedRow && selectedRow.length > 0) {
    //   status1 = String(selectedRow[0]['status']);
    //   if (status1 === 'Closed') {
    //     if(intmatchid.length > 1 || extmatchid.length > 1){
    //       return
    //     }
    //   }
    // }

    const lastDictionary = selectedRow[selectedRow.length - 1];

    setOpenGridHidden(true);
    setDuplicateHidden(true);
    setShow2(false);
    let matchid = '';
    let status1 = '';
    if (selectedRow && selectedRow.length > 0) {
      let data = selectedRow[0]['primary_id'];
      matchid = String(selectedRow[0]['match_id']);
      status1 = String(selectedRow[0]['status']);
      console.log(data, matchid, extGridData);
      setismatched({ value: "Closed", label: "Closed" });
      let intern_stmnt_id = String(selectedRow[0]['primary_id']);
      fetchremarksinfo(intern_stmnt_id);
      // setOpenGridHidden(false);
      // setDuplicateHidden(false);
      // setShow2(true);
      // setmatchidslist();
      
      setOpenGridHidden(false);
      setChartHidden(true);
    } else {
      console.log('else')

      setmodelcolumnnames1([]);
      setmodelcolumnnames([]);
      setintmatchid([]);
      handleClose();
      setChartHidden(false);
    }

    const filteredData = extGridData.filter(item => item.match_id === parseInt(matchid));
    console.log('filteredData----', filteredData,matchid);
    if (filteredData && filteredData.length > 0) {
    }
    if (status1 === 'Unmatched') {
      setismatched({ value: "Unmatched", label: "Open" });
      setOpenIntGridData(selectedRow);
      // setOpenIntGridData((prevSelectedRow) => ([
      //   ...prevSelectedRow, // Preserve the previous state
      //   ...selectedRow,  // Update with the new value
      // ]));
    }

    else if (selectedRow && selectedRow.length > 0) {
      // setintmatchid((prevCount) =>[
      //   ...prevCount,
      //   matchid
      // ]);
      setintmatchid(matchid)
      if (intmatchid && intmatchid.indexOf(matchid) !== -1) {
        console.log('if')
      
      }else{
        console.log('else',matchid);
        status1 = String(selectedRow[0]['status']);
       if (status1 === 'Match') {
        setOpenExtGridData([]);
        setOpenIntGridData([]);
        // setInternalAmount(0.00);
        // setExternalAmount(0.00);
       }
      getmatchedidrecords(matchid, 'intern');
      getgridClickedDataReturn(matchid);
      }
    }



  };

  const onGridReadyInt = (params) => {
    const { api } = params;
    gridApiInt = api;
  };


  const ClickView = () => {
    setShow2(true);
    setOpenGridHidden(false);
    setDuplicateHidden(false);
  }

  const handleCheckboxChangeExt = (event) => {
    const selectedRow = event.api.getSelectedRows();
    console.log("external selected checkbox row", selectedRow);

    // if (selectedRow && selectedRow.length > 0) {
    //   status1 = String(selectedRow[0]['status']);
    //   if (status1 === 'Closed') {
    //     if(intmatchid.length > 1 || extmatchid.length > 1){
    //       return
    //     }
    //   }
    // }

    const lastDictionary = selectedRow[selectedRow.length - 1];

    setOpenGridHidden(true);
    setDuplicateHidden(true);
    setShow2(false);
    let matchid = '';
    let status1 = '';
    if (selectedRow && selectedRow.length > 0) {
      let data = selectedRow[0]['primary_id'];
      matchid = String(selectedRow[0]['match_id']);
      status1 = String(selectedRow[0]['status']);
      console.log(data, matchid, extGridData);
      setismatched({ value: "Closed", label: "Closed" });
      let extern_stmnt_id = String(selectedRow[0]['primary_id']);
      fetchremarksinfo1(extern_stmnt_id);
      // setOpenGridHidden(false);
      // setDuplicateHidden(false);
      // setShow2(true);
      // setmatchidslist();
      
      setOpenGridHidden(false);
      setChartHidden(true);
    } else {
      console.log('else')

      setmodelcolumnnames1([]);
      setmodelcolumnnames([]);
      setintmatchid([]);
      handleClose();
      setChartHidden(false);
    }

    const filteredData = intGridData.filter(item => item.Match_id === parseInt(matchid));
    console.log('filteredData----', filteredData);
    if (filteredData && filteredData.length > 0) {
    }
    if (status1 === 'Unmatched') {
      setismatched({ value: "Unmatched", label: "Open" });
      setOpenExtGridData(selectedRow);
      // setOpenIntGridData((prevSelectedRow) => ([
      //   ...prevSelectedRow, // Preserve the previous state
      //   ...selectedRow,  // Update with the new value
      // ]));
    }

    else if (selectedRow && selectedRow.length > 0) {
      // setintmatchid((prevCount) =>[
      //   ...prevCount,
      //   matchid
      // ]);
      setextmatchid(matchid)
      if (intmatchid && intmatchid.indexOf(matchid) !== -1) {
        console.log('if')
      
      }else{
        console.log('else');
        status1 = String(selectedRow[0]['status']);
       if (status1 === 'Closed') {
        setOpenExtGridData([]);
        setOpenIntGridData([]);
        setInternalAmount(0.00);
        setExternalAmount(0.00);
       }
      getmatchedidrecords(matchid, 'intern');
      getgridClickedDataReturn(matchid);
      }
    }



  };

  // const handleCheckboxChangeExt = (event) => {
  //   const selectedRow = event.api.getSelectedRows();
  //   let matchid = '';
  //   let status1 = '';
  //   // Get the last dictionary (object) from the JSON array
  //   const lastDictionary = selectedRow[selectedRow.length - 1];
  //   if (selectedRow && selectedRow.length > 0) {
  //     matchid = String(selectedRow[0]['matched_id']);
  //     status1 = String(selectedRow[0]['status']);

  //     console.log('status1', status1);
  //     setismatched({ value: "Closed", label: "Closed" });
  //     setOpenGridHidden(false);
  //     setChartHidden(true);
  //   } else {
  //     setmodelcolumnnames1([]);
  //     setmodelcolumnnames([]);
  //     setintmatchid([]);
  //     handleClose();
      
  //     setChartHidden(false);
  //   }

  //   if (status1 === 'open') {
  //     // getmatchedidrecords(matchid);
  //     // getgridClickedDataReturn(matchid); 
  //     console.log('selectedRow', selectedRow);
  //     setismatched({ value: "Open", label: "Open" });
  //     setOpenExtGridData(
  //       selectedRow
  //     );

  //     // setOpenExtGridData((prevSelectedRow) => ([
  //     //   ...prevSelectedRow, // Preserve the previous state
  //     //   ...selectedRow,  // Update with the new value
  //     // ]));
  //   }
  //   else if (selectedRow && selectedRow.length > 0) {
  //     setextmatchid((prevCount) =>[
  //       ...prevCount,
  //       matchid
  //     ]);
      
  //     if (extmatchid && extmatchid.indexOf(matchid) !== -1) {
  //       console.log('')
  //     }else{
  //       status1 = String(selectedRow[0]['status']);
  //      if (status1 === 'Closed') {
  //       setOpenExtGridData([]);
  //       setOpenIntGridData([]);
  //       setInternalAmount(0.00);
  //       setExternalAmount(0.00);
  //      }
  //       getmatchedidrecords(matchid, 'extern');
  //       getgridClickedDataReturn(matchid);
  //     }

  //   }

   
  // };


  useEffect(() => {
    filterRowData();
  }, [selectedId]);

  const formatCurrency = (value) => {
    return value.toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
    });
  };


  const filterRowData = () => {
    console.log("hi", selectedId)
    if (selectedId) {
      const apiInt = agIntGridRef.current.api;
      const apiExt = agExtGridRef.current.api;

      let indexInt = 0;
      apiInt.forEachNodeAfterFilterAndSort((rowNode) => {
        const rowData = rowNode.data;
        // if (rowNode.data.matched_id === selectedId) {
        if (rowData && rowData.hasOwnProperty('matched_id') && rowData.matched_id === selectedId) {

          intMatchingRows[indexInt] = rowData;
          indexInt++;
        }
      });

      let idsum = 0;
      let icsum = 0;
      Object.values(intMatchingRows).forEach((rowData) => {
        // Check if the rowData has the 'amount' field
        if (rowData && rowData.hasOwnProperty(intDebit)) {
          // Add the amount to the sum
          idsum += rowData[intDebit];
          icsum += rowData[intCredit];
          let intAmount = idsum - icsum
          const formattedAmount = formatCurrency(intAmount);
          console.log('formattedAmount', formattedAmount);
          // setInternalAmount(formattedAmount);

          const number = 123456.78;
          const usFormatter = new Intl.NumberFormat("en-IN");
          console.log('ind', usFormatter.format(number));
        }
      });

      let indexExt = 0;
      apiExt.forEachNodeAfterFilterAndSort((rowNode) => {
        const rowData = rowNode.data;
        // if (rowNode.data.matched_id === selectedId) {
        if (rowData && rowData.hasOwnProperty('matched_id') && rowData.matched_id === selectedId) {

          extMatchingRows[indexExt] = rowData;
          indexExt++;
        }
      });

      let edsum = 0;
      let ecsum = 0;
      Object.values(extMatchingRows).forEach((rowData) => {
        // Check if the rowData has the 'amount' field
        if (rowData && rowData.hasOwnProperty(extDebit)) {
          // Add the amount to the sum
          edsum += rowData[extDebit];
          ecsum += rowData[extCredit];
          let extAmount = ecsum - edsum
          const formattedAmount1 = formatCurrency(extAmount);
          // console.log('formattedAmount1', formattedAmount1)
          // setExternalAmount(formattedAmount1);

          const number = 123456.78;
          const usFormatter = new Intl.NumberFormat("en-IN");
          console.log(usFormatter.format(number));
        }
      });

      if (intMatchingRows) {
        setOpenIntGridData(intMatchingRows);
      }
      if (extMatchingRows) {
        setOpenExtGridData(extMatchingRows);
      }
    } else {
      setOpenIntGridData([]);
      setOpenExtGridData([]);
    }
  };

  const OpenExtColumnDefs1 = React.useMemo(() => {
    if (openExtGridData.length > 0) {
      console.log("openExtGridData", openExtGridData);
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openExtGridData[0]);

      // Create column definitions with the checkbox as the first column
      const OpenExtColumnDefs = [
        // {
        //   headerName: '',
        //   checkboxSelection: true,
        //   width: 50,
        // },
        ...keys
          .filter((key) => key !== 'id') // Filter out the "id" column
          .map((key) => {
            // Calculate the maximum content width for the current column
            const maxWidth = openExtGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );

            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
            };
          }),
      ];

      return OpenExtColumnDefs;
    }
    return [];
  }, [openExtGridData]);

  const OpenIntColumnDefs9 = React.useMemo(() => {
    if (openIntGridData.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openIntGridData[0]);

      // Create column definitions with the checkbox as the first column
      const OpenIntColumnDefs = [
        // {
        //   headerName: '',
        //   checkboxSelection: true,
        //   width: 50,
        // },
        ...keys
          .filter((key) => key !== 'id') // Filter out the "id" column
          .map((key) => {
            // Calculate the maximum content width for the current column
            const maxWidth = openIntGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );

            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
            };
          }),
      ];

      return OpenIntColumnDefs;
    }
    return [];
  }, [openIntGridData]);

  function matchClick() {
    console.log("idss", openIntGridData.map(row => row.id))
    setLoaderOpen(true);
    let payload = {
      "int_name": intName,
      "ext_name": extName,
      "int_id": openIntGridData.map(row => row.id),
      "ext_id": openExtGridData.map(row => row.id),
      "user_id": userCredentials["user_id"]
    }

    const amountInt = internalAmount.toString().replace(/-/g, "");
    const amountExt = externalAmount.toString().replace(/-/g, "");
    const total = (amountInt - amountExt).toString().replace(/-/g, "");
    console.log("total", total);

    if (total <= amountTolerance) {

      var getMatchRecords = getUpdateMatchRecordsFromServer();

      axios.post(getMatchRecords[1], { params: payload }, getMatchRecords[0])
        .then(
          response => {
            console.log("Matched the selected Records!!!", response)
            let data = response["data"];
            if (data["Status"] === "Success") {
              console.log("data", data);
              setDoughnutLabel([]);
              setDoughnutData([]);
              setIntGridData([]);
              setExtGridData([]);
              setUnMatchedHidden(true);
              setOpenGridHidden(true);
              setOpenIntGridData([]);
              setOpenExtGridData([]);
              setUnMatchHidden(true);
              Promise.all([
                processingLayerDataReturn(),
                getChartClickedDataReturn(label)
              ]).then(() => {
                alert("Records Matched Successfully!!!");
                setLoaderOpen(false);
              });
            }
            else {
              alert("Error In Matching!!!");
              setLoaderOpen(false);
            }
          }
        ).catch(
          error => {
            console.log("Error in Matching Records!!!", error);
            setLoaderOpen(false);
          }
        );
    }
    else {
      alert("Amounts Are Not Matching!!!");
      setLoaderOpen(false);
    }

  }

  function duplicateClick() {
    setLoaderOpen(true);
    let payload = {
      "int_name": intName,
      "ext_name": extName,
      "int_id": openIntGridData.map(row => row.id),
      "ext_id": openExtGridData.map(row => row.id),
      "user_id": userCredentials["user_id"]
    }

    var getDuplicateRecords = getUpdateDuplicateRecordsFromServer();

    axios.post(getDuplicateRecords[1], { params: payload }, getDuplicateRecords[0])
      .then(
        response => {
          console.log("Duplicated the selected Records!!!", response)
          let data = response["data"];
          if (data["Status"] === "Success") {
            console.log("data", data);
            setDoughnutLabel([]);
            setDoughnutData([]);
            setIntGridData([]);
            setExtGridData([]);
            setUnMatchedHidden(true);
            setOpenGridHidden(true);
            setOpenIntGridData([]);
            setOpenExtGridData([]);
            setUnMatchHidden(true);
            Promise.all([
              processingLayerDataReturn(),
              getChartClickedDataReturn(label)
            ]).then(() => {
              alert("Records Updated As Duplicate Successfully!!!");
              setLoaderOpen(false);
            });

          }
          else {
            alert("Error In Duplicating!!!");
            setLoaderOpen(false);
          }
        }
      ).catch(
        error => {
          console.log("Error in Updating Records Duplicate!!!", error);
          setLoaderOpen(false);
        }
      );


  }


  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = 'http://103.61.224.179:3100/logs/file.xlsx';
    link.download = 'file.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  function UnMatchClick() {
    setLoaderOpen(true);
    let payload = {
      "int_name": intName,
      "ext_name": extName,
      "int_id": openIntGridData.map(row => row.id),
      "ext_id": openExtGridData.map(row => row.id),
      "user_id": userCredentials["user_id"]
    }

    var getUnMatchRecords = getUpdateUnMatchRecordsFromServer();

    axios.post(getUnMatchRecords[1], { params: payload }, getUnMatchRecords[0])
      .then(
        response => {
          console.log("UMatched the selected Records!!!", response)
          let data = response["data"];
          if (data["Status"] === "Success") {
            console.log("data", data);
            setDoughnutLabel([]);
            setDoughnutData([]);
            setIntGridData([]);
            setExtGridData([]);
            setUnMatchedHidden(true);
            setOpenGridHidden(true);
            setOpenIntGridData([]);
            setOpenExtGridData([]);
            setUnMatchHidden(true);
            Promise.all([
              processingLayerDataReturn(),
              getChartClickedDataReturn(label)
            ]).then(() => {
              alert("Records UnMatched Successfully!!!");
              setLoaderOpen(false);
            });
          }
          else {
            alert("Error In UnMatching!!!");
            setLoaderOpen(false);
          }
        }
      ).catch(
        error => {
          console.log("Error in Updating Records UnMatched!!!", error);
          setLoaderOpen(false);
        }
      );


  }

  function contraClick() {
    setLoaderOpen(true);
    let payload = {
      "int_name": intName,
      "ext_name": extName,
      "int_id": openIntGridData.map(row => row.id),
      "ext_id": openExtGridData.map(row => row.id),
      "user_id": userCredentials["user_id"]
    }

    const amountInt = internalAmount.toString().replace(/-/g, "");
    const amountExt = externalAmount.toString().replace(/-/g, "");
    const total = (amountInt - amountExt).toString().replace(/-/g, "");
    console.log("total", total);

    // if (total === '0'){

    var getContraRecords = getUpdateContraRecordsFromServer();

    axios.post(getContraRecords[1], { params: payload }, getContraRecords[0])
      .then(
        response => {
          console.log("Match the selected Records As Contra!!!", response)
          let data = response["data"];
          if (data["Status"] === "Success") {
            console.log("data", data);
            setDoughnutLabel([]);
            setDoughnutData([]);
            setIntGridData([]);
            setExtGridData([]);
            setUnMatchedHidden(true);
            setOpenGridHidden(true);
            setOpenIntGridData([]);
            setOpenExtGridData([]);
            setUnMatchHidden(true);
            Promise.all([
              processingLayerDataReturn(),
              getChartClickedDataReturn(label)
            ]).then(() => {
              alert("Records Updated As Contra Successfully!!!");
              setLoaderOpen(false);
            });
          }
          else {
            alert("Error In Contra Matching!!!");
            setLoaderOpen(false);
          }
        }
      ).catch(
        error => {
          console.log("Error in Contra Matching Records!!!", error);
          setLoaderOpen(false);
        }
      );
    // }
    // else{
    //   alert("Amounts Are Not Matching!!!");
    //   setLoaderOpen(false);
    // }

  }

  function glBalClick() {
    setLoaderOpen(true);
    let payload = {
      "int_name": intName,
      "ext_name": extName,
      "int_cr": intCredit,
      "int_dr": intDebit,
      "processing_layer_id": layerId,
      "intDate": intDate
    }

    if (selectedOption.length > 0) {
      var getGlBal = getUpdateGlBalFromServer();

      axios.post(getGlBal[1], { params: payload }, getGlBal[0])
        .then(
          response => {
            console.log("GL Balances Update Response!!!", response)
            let data = response["data"];
            if (data["Status"] === "Success") {
              alert("GL Balance Updated Successfully!!!");
              setLoaderOpen(false);
            }
            else {
              // alert("Error In Matching!!!");
              setLoaderOpen(false);
            }
          }
        ).catch(
          error => {
            console.log("Error in Updating Balances!!!", error);
            setLoaderOpen(false);
          }
        );
    }
    else {
      alert("Please Select The Reconciliation Type!!!");
      setLoaderOpen(false);
    }
  }

  function BankBalClick() {
    setLoaderOpen(true);
    let payload = {
      "ext_name": extName,
      "ext_cr": extCredit,
      "ext_dr": extDebit,
      "processing_layer_id": layerId,
      "extDate": extDate
    }

    if (selectedOption.length > 0) {
      var getBankBal = getUpdateBankBalFromServer();

      axios.post(getBankBal[1], { params: payload }, getBankBal[0])
        .then(
          response => {
            console.log("Bank Balances Update Response!!!", response)
            let data = response["data"];
            if (data["Status"] === "Success") {
              alert("Bank Balance Updated Successfully!!!");
              setLoaderOpen(false);
            }
            else {
              // alert("Error In Matching!!!");
              setLoaderOpen(false);
            }
          }
        ).catch(
          error => {
            console.log("Error in Updating Bank Balances!!!", error);
            setLoaderOpen(false);
          }
        );
    }
    else {
      alert("Please Select The Reconciliation Type!!!");
      setLoaderOpen(false);
    }
  }

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

  // const gridOptions = {
  //   suppressCopyRowsToClipboard: false,
  //   // Other grid options...
  // };


  function getExceptiontypedata1(exception) {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],
      'exception': exception,
      'client_id': selectedOption1.value

    }

    var getProcessingLayerDataWithStatus = getdataforcardsrecon();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setremarksdata(data1);
          setShow5(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const showmodel = () => {
    setShow3(true);
  }

  const showmodelremarks = () => {
    setShow5(true);
  }


  const getFirstcarddata = () => {
    getExceptiontypedata1('Total')
  }

  const getFirstcarddata1 = () => {
    getExceptiontypedata1('Outstanding')
  }

  const getFirstcarddata2 = () => {
    getExceptiontypedata1('Over due')
  }

  const ClickAllocateButton = () => {

    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],
      "intern": openIntGridData,
      "extern": openExtGridData,
      'funding_due_date': selectedDate,
      'client_name': selectedOption.label,
      'client_id': selectedOption1.value
    }

    console.log('payload', payload);
    var getProcessingLayerDataWithStatus = allocateupdatestatusvalue();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );

  }



  return (
    <div>
      <Grid columns='equal' divided style={{ paddingLeft: "10px", borderRadius: "15px", margin: '0em', marginTop: '-3.3em' }} className="mt-2 mb-2">
        <Grid.Row >
          <Grid.Column >

            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Bank</label> <br />
              <div className="reconsummary">
                <Select
                  clearable
                  options={options}
                  selection
                  size='mini'
                  onChange={handleSelection}
                  value={selectedOption}
                  style={{ backgroundColor: 'white' }}

                />
              </div>
            </div>

          </Grid.Column>
          <Grid.Column >

            <div className="form-group ">
              {/* <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Division</label> <br />
              <div className="reconsummary">
                <Select
                  clearable
                  options={clientids1}
                  selection
                  size='mini'
                  onChange={handleSelection1}
                  value={selectedOption1}

                /> */}
              {/* </div> */}
            </div>

          </Grid.Column>

          <Grid.Column style={{ border: '1px solid #111111', marginRight: '10px', background: 'white', height: '130px', borderRadius: '10px' }} onClick={getFirstcarddata}>
            <Card className="custom-card" style={{ background: '#6d7991', marginTop: '.43em' }}>
              <Card.Content style={{ width: '108%' }}> <Card.Header style={{ fontSize: '17px', color: 'white', textAlign: 'center' }}>ERP closingbalance</Card.Header></Card.Content>
              <Card.Content style={{ fontSize: '1.8rem' }}>

                <Card.Description style={{ fontWeight: '700', color: 'white' }}>{erpbalance}</Card.Description>
              </Card.Content>

            </Card>
          </Grid.Column>
          <Grid.Column style={{ border: '1px solid #111111', marginRight: '10px', background: 'white', height: '130px', borderRadius: '10px' }} onClick={getFirstcarddata1}>
            <Card className="custom-card" style={{ background: '#6d7991', border: '1px solid #111111', marginTop: '.43em' }}>
              <Card.Content style={{ width: '108%' }}> <Card.Header style={{ fontSize: '17px', color: 'white', textAlign: 'center' }}>Bank Closingbalance</Card.Header></Card.Content>
              <Card.Content style={{ fontSize: '1.8rem' }}>

                <Card.Description style={{ fontWeight: '700', color: 'white' }}>{bankbalance}</Card.Description>
              </Card.Content>

            </Card>
          </Grid.Column>
          <Grid.Column style={{ border: '1px solid #111111', background: 'white', height: '130px', borderRadius: '10px' }} onClick={getFirstcarddata2}>
            <Card className="custom-card" style={{ background: '#6d7991', border: '1px solid #111111', marginTop: '.43em' }}>
              <Card.Content style={{ width: '108%' }}> <Card.Header style={{ fontSize: '17px', color: 'white', textAlign: 'center' }}>Variance</Card.Header></Card.Content>
              <Card.Content style={{ fontSize: '1.8rem' }}>

                <Card.Description style={{ fontWeight: '700', color: 'white' }}>{difference}</Card.Description>
              </Card.Content>

            </Card>
          </Grid.Column>


        </Grid.Row>
      </Grid>

      <Grid columns='equal' divided hidden={chartHidden}>
        <Grid.Row style={{ margin: '1.4em', marginTop: '-2.3em', marginBottom:'0px' }}>
          <Grid.Column style={{ borderRadius: '10px', marginRight: '10px', border: '1px solid #111111', backgroundColor: 'white' }} hidden={chartHidden}>
            <DynamicDonutChart options={chartData1.labels} series={chartData1.series} onClick={handleChartClick} />
          </Grid.Column>
      <Grid.Column style={{ borderRadius: '10px', marginRight: '10px', border: '1px solid #111111', backgroundColor: 'white' }} hidden={chartHidden}>
        <div style={{ marginBottom: '10px' }}> {/* Adding margin bottom to create space */}
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            dateFormat="MMMM yyyy"
            showMonthYearPicker
          />
        </div>
        <DynamicDonutChart options={chartData1.labels} series={chartData1.series} onClick={handleChartClick} />
      </Grid.Column>

          <Grid.Column style={{ borderRadius: '10px', marginRight: '10px', border: '1px solid #111111', padding: '10px', backgroundColor: 'white' }} hidden={chartHidden}><BarChart /></Grid.Column>
          <Grid.Column style={{ borderRadius: '10px', border: '1px solid #111111', backgroundColor: 'white' }} hidden={chartHidden}>
            {/* <div className="row">
              <div className="col-md-6" style={{ paddingTop: '10px' }}>
                <Select
                  clearable
                  options={payment_history_dropdowns}
                  selection
                  size='mini'
                  onChange={changedropdown1}
                  value={dropdown1}

                />
              </div> */}
              {/* <div className="col-md-5">
                <Select
                  clearable
                  options={payment_history_dropdowns1}
                  selection
                  size='mini'
                  onChange={changedropdown2}
                  value={dropdown2}
                />
              </div> */}

            {/* </div> */}

            {/* <BarChart1 /> */}
          </Grid.Column> 
        </Grid.Row>
      </Grid>
      

      <div hidden={openGridHidden}>
        <div className="row" style = {{marginTop:"10px"}}>
          <div className="col-md-2 mb-3 mr-3 " style={{marginLeft:'1em'}}>
            <Select
              clearable
              options={optionslist}
              selection
              size='mini'
              onChange={handleSelectionmatched}
              value={ismatched}

            />
          </div>

          <div className="col-md-2">
            <button className="btn pr-2" style={{ height: "35px", width: "92px", marginTop: "5px", backgroundColor: "#000055", color: "#ffffff" }} onClick={ClickSaveButton}>Save</button>
          </div>
        </div>


        {/* <Grid columns='equal' divided>
          <Grid.Row style={{ marginBottom: '1.5em' }}>
            <Grid.Column>
              <div className="ag-theme-alpine" style={{ height: '400px', width: '100%', marginLeft: '1.7em' }}>
                <h4 style={{ margin: 0 }} className="heading">PAYMENTS : Rs. {externalAmount}</h4>
                <AgGridReact columnDefs={bankcolumnnames} rowData={openExtGridData} animateRows={true}
                  // rowSelection={'multiple'}
                  pagination={true}
                  paginationPageSize={10}
                  groupSelectsChildren={true}
                  suppressAggAtRootLevel={true}
                  suppressRowClickSelection={true} />
              </div>
            </Grid.Column>
            <Grid.Column>
              <div className="ag-theme-alpine col-md-5" style={{ height: '400px', width: '100%', marginLeft: '0.1em' }}>
                <h4 className="heading" style={{ margin: '0' }}>INVOICES : Rs.  {internalAmount}</h4>
                <AgGridReact columnDefs={arcolumnnames} rowData={openIntGridData} animateRows={true}
                  // rowSelection={'multiple'}
                  pagination={true}
                  paginationPageSize={10}
                  groupSelectsChildren={true}
                  suppressAggAtRootLevel={true}
                  suppressRowClickSelection={true} />
              </div>

            </Grid.Column>
          </Grid.Row>
        </Grid> */}



<div className="grid-container2">
  <Grid.Row>
          <div className="ag-theme-alpine" style={{ height: '400px', width: '100%', marginLeft: '7px' }}>
          <h4 style={{ margin: 0 }} className="heading">Bank : Rs. {externalAmount}</h4>
                <AgGridReact columnDefs={bankcolumnnames} rowData={openExtGridData} animateRows={true}
                  rowSelection={'multiple'}
                  pagination={true}
                  paginationPageSize={12}
                  groupSelectsChildren={true}
                  suppressAggAtRootLevel={true}
                  suppressRowClickSelection={true} 
                  suppressFieldDotNotation={true}

                  rowHeight={30}/>
          </div>
    </Grid.Row>
    <Grid.Row>
          <div className="ag-theme-alpine" style={{ height: '400px', width: '99%' }}>
          <h4 className="heading" style={{ margin: '0' }}>ERP : Rs.  {internalAmount}</h4>
                <AgGridReact columnDefs={arcolumnnames} rowData={openIntGridData} animateRows={true}
                  rowSelection={'multiple'}
                  pagination={true}
                  paginationPageSize={12}
                  groupSelectsChildren={true}
                  suppressAggAtRootLevel={true}
                  suppressRowClickSelection={true}
                  suppressFieldDotNotation={true}
                  rowHeight={30} />

          </div>
          </Grid.Row>
        </div>

      </div>

      <div>
      
      {showDialog && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999 // Make sure it appears above other content
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)'
            }}
          >
            <h2>Month End Closing Balances</h2>

    <div style={{ marginBottom: '10px' }}>
              <label htmlFor="balance">Month:</label>
              <div style={{ display: 'inline-block', marginLeft: '10px', border: '1px solid #ccc', padding: '5px' }}>
               {monthclosure}
              </div>
            </div>
          
    <div style={{ marginBottom: '10px' }}>
              <label htmlFor="balance">ERP Closing Balance:</label>
              <div style={{ display: 'inline-block', marginLeft: '10px', border: '1px solid #ccc', padding: '5px' }}>
               {erpclosure}
              </div>
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label htmlFor="otherField">Month Closing Balance</label>
              <div style={{ display: 'inline-block', marginLeft: '10px', border: '1px solid #ccc', padding: '5px' }}>
                {bankclosure}
              </div>
              </div>
            <div>
            <button onClick={handleClose1} style={{ marginRight: '10px' }}>Close</button>
            <button onClick={lockmonthendbalance}>Lock</button>
            </div>

          </div>
        </div>
      )}
    </div>




      <div hidden={unMatchedHidden} style={{ paddingTop: '1.2em' }}>
        <div className="row">
          <div className="col-md-7">
            <div className="search-input-container" style={{ marginTop: '-1.5em' }}>
              <i className="fa fa-search search-icon"></i>
              <input className="search-input" type="text" placeholder="Search..." value={searchText} onChange={onFilterTextChange} style={{ width: '30%' }} />
            </div>

          </div>

          <div className="col-md-2">
            <button className="btn pr-2" style={{ height: "35px", width: "92px", marginTop: "5px", backgroundColor: "#000055", color: "#ffffff" }} onClick={handleClick}>close</button>
          </div>
          
        </div>
        <div className="grid-container2">
          <div className="ag-theme-alpine" style={{ height: '400px', width: '100%', marginLeft: '7px' }}>
            <h3 className="heading"> BANK</h3>
            <AgGridReact columnDefs={bankcolumnnames} rowData={extGridData} animateRows={true}
              ref={agExtGridRef}
              rowSelection={'multiple'}
              // rowSelection={isMultiSelect}
              pagination={true}
              paginationPageSize={12}
              groupSelectsChildren={true}
              suppressAggAtRootLevel={true}
              onRowSelected={handleCheckboxChangeExt}
              suppressRowClickSelection={true}
              quickFilterText={searchText}
              enableRangeSelection={true}
              enableRangeCopy={true}
              onGridReady={onGridReady} 
              suppressFieldDotNotation={true}
              enableCellTextSelection= {true}
              rowHeight={30}/>
          </div>
          <div className="ag-theme-alpine" style={{ height: '400px', width: '99%' }}>
            <h3 className="heading">ERP</h3>
            <AgGridReact columnDefs={arcolumnnames} rowData={intGridData} animateRows={true}
              ref={agIntGridRef}
              rowSelection={'multiple'}
              pagination={true}
              paginationPageSize={12}
              groupSelectsChildren={true}
              suppressAggAtRootLevel={true}
              onRowSelected={handleCheckboxChangeInt}
              suppressRowClickSelection={true}
              quickFilterText={searchText}
              onGridReady={onGridReadyInt} 
              suppressFieldDotNotation={true}
              enableCellTextSelection= {true}
              rowHeight={30}/>

          </div>
        </div>
      </div>
      <LoaderComponent loaderOpen={loaderOpen} />

      <Modal
        show={show3}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Internal Statement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ag-theme-alpine"
            style={{ height: '300px', width: '100%' }}
          >
            <RenderGrid
              columnDefs={modelcolumnnames}
              rowData={modelcolumnnames1}
              animateRows={true}

              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show5}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ag-theme-alpine"
            style={{ height: '300px', width: '100%' }}
          >
            <RenderGrid
              columnDefs={remarkscol}
              rowData={remarksdata}
              animateRows={true}

              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
        
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show6}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ag-theme-alpine"
            style={{ height: '300px', width: '100%' }}
          >
            <RenderGrid
              columnDefs={remarkscol1}
              rowData={remarksdata1}
              animateRows={true}

              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ReconSummary;